import React from 'react';
import DefaultLayout from '../../../layouts/default';
import { UserFormProvider } from '../context/UserFormContext';
import UserFormContent from '../components/UserFormContent';
export default function CreateUsersPage() {
  return <DefaultLayout><UserFormProvider><UserFormContent /></UserFormProvider></DefaultLayout>;
}
